<template>
    <div>
         <div class="chit_header">
            <img :src="webUrl+'assets/jobeekerImages/Group 16@2x.png'">
       </div>
    </div>
</template>
<script>
import loadJobseekersNewCss from "@/mixins/loadJobseekersNewCss";

export default {
    mixins: [loadJobseekersNewCss],
    data() {
        return {
            webUrl: process.env.VUE_APP_URL,
        }
    },
}
</script>

<style scoped>
  /* jobseekers-new.css is loaded on-demand (async) via the loadJobseekersNewCss mixin — see script */
  @import '/assets/css/common-font-family.css';
</style>
